var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVulnerability = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 37 37",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.149 20.54c0-5.312 4.305-9.617 9.618-9.617q.27 0 .538.015V5.705a3.22 3.22 0 0 0-3.217-3.216h-.829v2.88c0 .86-.7 1.56-1.56 1.56H14.21c-.859 0-1.56-.7-1.56-1.56V2.49h-.829a3.22 3.22 0 0 0-3.217 3.216v25.923a3.22 3.22 0 0 0 3.217 3.215h13.267a3.22 3.22 0 0 0 3.217-3.216v-1.485q-.266.015-.538.015a9.617 9.617 0 0 1-9.618-9.617"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.468 19.356h-1.63v-.12c0-.398-.059-.783-.167-1.147l1.47-1.469a1.081 1.081 0 0 0-1.528-1.527l-1.128 1.128a4.041 4.041 0 0 0-5.404.012l-1.14-1.14a1.081 1.081 0 0 0-1.528 1.527l1.49 1.49q-.16.537-.161 1.128v.12h-1.655a1.08 1.08 0 0 0 0 2.16h1.655v.187q.002.556.144 1.069l-1.473 1.472a1.081 1.081 0 0 0 .764 1.845c.276 0 .553-.106.763-.317l1.1-1.1a4.03 4.03 0 0 0 2.748 1.078c1.061 0 2.014-.404 2.735-1.066l1.088 1.088a1.076 1.076 0 0 0 1.527 0 1.08 1.08 0 0 0 0-1.528l-1.452-1.452c.097-.346.15-.711.15-1.088v-.187h1.63a1.08 1.08 0 0 0 0-2.16zm-3.79.849a1.05 1.05 0 0 0 0 .463v1.036a1.889 1.889 0 0 1-3.775 0v-2.468a1.889 1.889 0 0 1 3.775 0zM22.099 2.76H14.81v2.008H22.1z"
  })));
};
export default SvgVulnerability;